import React, { useState } from "react";
import { BiSolidMessageDetail } from "react-icons/bi";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import AuthWrapper from "../../components/AuthWrapper";
import FormInput from "../../components/formInput/FormInput";
import { ResetUserPassword } from "../../firebase/utility";
import { Button, Spinner } from 'reactstrap';

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleResetPassword = () => {
    if (email !== "") {
      setLoading(true);
      ResetUserPassword(email).then((res) => {
        if (res.success) {
          toast.success("Please check your email to update Password!");
          setEmail("");
          history.push("/auth/login");
        } else {
          toast.error(`Something went wrong: ${res.message}`);
          setEmail("");
        }
        setLoading(false);
      });
    } else {
      toast.error("Please enter your email!");
    }
  };

  return (
    <>
      <AuthWrapper
        title={"Forgot Password"}
        description={
          "Don't worry! Enter your email and we'll send you a link to reset your access."
        }
      >
        <div className="d-flex flex-column gap-3 mt-2">
            <div>
                <label className="form-label small fw-600 text-muted mb-1">Recovery Email</label>
                <FormInput
                    type={"text"}
                    placeholder={"admin@techmicro.com"}
                    className="w-100 rounded-3 border-light py-2"
                    size={"large"}
                    value={email}
                    handleChange={(e) => setEmail(e.target.value)}
                />
            </div>

            <div className="mt-2">
                <Button
                    className="w-100 rounded-3 border-0 py-2 shadow-sm text-white fw-600"
                    style={{
                        background: "linear-gradient(90deg, #00509d, #182848)",
                        height: "48px"
                    }}
                    onClick={handleResetPassword}
                    disabled={loading}
                >
                    {loading ? <Spinner size="sm" /> : "Send Reset Link"}
                </Button>
            </div>

            <div className="text-center mt-3">
                <Link to="/auth/login" className="text-decoration-none text-muted small fw-600">
                    Remember your password? <span className="text-primary">Back to Login</span>
                </Link>
            </div>
        </div>
      </AuthWrapper>
    </>
  );
};

export default ResetPassword;

